module.exports = __webpack_public_path__ + "fonts/adellesans-light-webfont.fe4f8ac0.woff2";